<div class="header-content-footer-root">
  <app-user-header *ngIf="isMobile" [imgSource]="profilePicture"></app-user-header>
  <div class="content">
    <ng-content select="[content]"></ng-content>
  </div>
  <app-navigation-bar *ngIf="isMobile" class="footer"></app-navigation-bar>
</div>
